export default "__VITE_PUBLIC_ASSET__431dc833__"